import {
  COMPANY_INFORMATION_URL,
  LIABLE_PARTNER_URL,
  LOGISTIC_ADDRESS_URL,
  PERSONAL_INFORMATION_URL,
} from '../../utils/urls';

export const ROUTES_MATCH_PATHS = {
  logisticAddress: {
    path: [LOGISTIC_ADDRESS_URL, PERSONAL_INFORMATION_URL],
  },
  companyInformation: {
    path: [COMPANY_INFORMATION_URL],
  },
  liablePartner: {
    path: [LIABLE_PARTNER_URL],
  },
};

export const MIXPANEL_EVENTS_PERSONAL_INFORMATION = {
  LOGISTIC_ADDRESS_PATH: 'PERSONAL_INFORMATION__LOGISTIC_ADDRESS_PATH',
  COMPANY_INFORMATION_PATH: 'PERSONAL_INFORMATION__COMPANY_INFORMATION_PATH',
  LIABLE_PARTNER_PATH: 'PERSONAL_INFORMATION__LIABLE_PARTNER_PATH',
};
